import { format, utcToZonedTime } from 'date-fns-tz'

interface IDate {
  date: string
  time: string
  timezone: string
}

export const USER_PREFERENCES_TIMEZONE =
  Intl.DateTimeFormat().resolvedOptions().timeZone

export const formatDate = (stringDate: string, timezone?: string) => {
  const selectedTimezone = !timezone ? USER_PREFERENCES_TIMEZONE : timezone

  try {
    const zonedDate = utcToZonedTime(stringDate, selectedTimezone)
    const formattedDate = format(zonedDate, 'yyyy-MM-dd HH:mm xxx z', {
      timeZone: selectedTimezone,
    })
    const [date, time, timeZoneHours, timezone] = formattedDate.split(' ')

    return {
      date,
      time,
      timeZoneHours,
      timezone,
      selectedTimezone,
      utcOffset: generateUTCoffset(timeZoneHours),
    }
  } catch (e) {
    return {
      date: '—',
    }
  }
}

export const generateUTCoffset = (date: string) => {
  const sign = date[0]
  const number = parseInt(date.substring(1), 10)
  return `UTC${sign}${number}`
}

const isValidDate = (date: string) => date !== '—'

const createDateTimeString = (data: IDate) =>
  `${data.date}T${data.time}:00${data.timezone}`

export const orderByDescending = (a: IDate, b: IDate) => {
  if (!isValidDate(a.date)) {
    return 1
  }

  if (!isValidDate(b.date)) {
    return -1
  }

  const dateTimeAString = createDateTimeString(a)
  const dateTimeBString = createDateTimeString(b)

  return dateTimeBString.localeCompare(dateTimeAString)
}
